export var Name = 'remove-customer-order';
export var RemoveCustomerOrderEvent = Name;